import React from 'react'

function MergeSubjectMobile() {
    return (
        <div>

        </div>
    )
}

export default MergeSubjectMobile